import { PROJECT_DETAILS, PARTICULAR_PRODUCT_DETAILS } from './actionTypes';
import transformations from './transformation';

const getProjectDetails = id => (dispatch, getState, { api }) => {
  dispatch({
    type: PROJECT_DETAILS.PROJECT_DETAILS_FETCH,
    payload: {},
    test: api
      .post(`projectDetail.json`, { url_slug: id })
      .then(res => {
        const response = res.data.result.data || {};
        dispatch({
          type: PROJECT_DETAILS.PROJECT_DETAILS_SUCCESS,
          payload: transformations.transformProjectDetails(response),
        });
      })
      .catch(error => {
        dispatch({
          type: PROJECT_DETAILS.PROJECT_DETAILS_FAILURE,
          error,
        });
      }),
  });
};

const getParticularProductDetails = project_url_slug => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: PARTICULAR_PRODUCT_DETAILS.PARTICULAR_PRODUCT_DETAILS_FETCH,
    payload: {},
    test: api
      .post(`productList.json`, { project_url_slug: project_url_slug })
      .then(res => {
        const response = res.data || {};
        dispatch({
          type: PARTICULAR_PRODUCT_DETAILS.PARTICULAR_PRODUCT_DETAILS_SUCCESS,
          payload: transformations.transformParticularProjectList(
            response,
            project_url_slug
          ),
        });
      })
      .catch(error => {
        dispatch({
          type: PARTICULAR_PRODUCT_DETAILS.PARTICULAR_PRODUCT_DETAILS_FAILURE,
          error,
        });
      }),
  });
};

export const ProjectBrowserActions = {
  getProjectDetails,
  getParticularProductDetails,
};
